import api from "@/lib/api";
import { toast } from "sonner";

// Authenticated file download (CSV/PDF) via axios blob, then trigger browser save.
export async function downloadFile(path, filename) {
  try {
    const res = await api.get(path, { responseType: "blob" });
    const url = window.URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (e) {
    toast.error("Download failed");
  }
}
